/**
 * @param {string} wrapId
 * @param elemWrap
 * @return {{name:string, value:string}[]|[]}
 */
let formSerializeArray = (wrapId, elemWrap = null) => {
    const wrap = wrapId ? document.getElementById(wrapId) : elemWrap;
    let list = [];

    if (wrap) {
        const elements = wrap.querySelectorAll('input,select,textarea');

        for (let elem of elements) {
            if (elem.name) {
                if ((elem.type === 'radio' || elem.type === 'checkbox') && elem.checked) {
                    list.push({
                        name: elem.name,
                        value: elem.value,
                    });
                } else if (elem.type !== 'radio' && elem.type !== 'checkbox') {
                    list.push({
                        name: elem.name,
                        value: elem.value,
                    });
                }
            }
        }
    }

    return list;
};

export default formSerializeArray;
